import { useState } from 'react';

import { Box } from '@chakra-ui/react';
import { Button } from '@mesh.ai/rabbit';
import { CancelConfirmationModal } from 'Deer/pages/Company/DisciplinaryActions/DisciplinaryActionsSettings/CancelConfirmationModal';

import { VIOLATION_STATUS } from '../types';

type ViewViolationManagerViewFooterProps = {
  violationStatus: keyof typeof VIOLATION_STATUS;
  onCancel: () => void;
  onPublish: () => void;
  onNotify: () => void;
  isPublishAllowed: boolean;
  onDelete: () => void;
};

export const ViewViolationManagerViewFooter = ({
  violationStatus,
  onCancel,
  onPublish = () => {},
  onNotify = () => {},
  onDelete = () => {},
  isPublishAllowed = false,
}: ViewViolationManagerViewFooterProps) => {
  const isCreated = violationStatus === VIOLATION_STATUS.CREATED;
  const isApproved = violationStatus === VIOLATION_STATUS.APPROVED;
  const isDenied = violationStatus === VIOLATION_STATUS.DENIED;
  const isPublished = violationStatus === VIOLATION_STATUS.PUBLISHED_TO_EMPLOYEE;
  const isAcknowledged = violationStatus === VIOLATION_STATUS.ACKNOWLEDGED;
  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] = useState(false);
  const isActionButtonVisible = isCreated || isApproved || isPublished;

  return (
    <Box
      display="flex"
      justifyContent={isActionButtonVisible ? 'space-between' : 'end'}
      h="72px"
      w="full"
      p="16px"
      bg="surface.F5F7F9"
      boxShadow="0px -1px 2px 0px #00000014"
    >
      <Button variant={isActionButtonVisible ? 'transparentOutline' : 'filled'} onClick={onCancel}>
        {isAcknowledged || isDenied ? 'Close' : 'Cancel'}
      </Button>

      {isCreated && (
        <Button variant="filled" onClick={() => setIsConfirmDeleteModalOpen(true)} status="error">
          Delete
        </Button>
      )}

      {isApproved && (
        <Button variant="filled" onClick={onPublish} disabled={!isPublishAllowed}>
          Publish to employee
        </Button>
      )}
      {isPublished && (
        <Button variant="filled" onClick={onNotify}>
          Notify employee
        </Button>
      )}
      {isConfirmDeleteModalOpen && (
        <CancelConfirmationModal
          isOpen={isConfirmDeleteModalOpen}
          onClose={() => setIsConfirmDeleteModalOpen(false)}
          onContinue={onDelete}
          modalAgenda="delete"
        />
      )}
    </Box>
  );
};
